import { useState } from 'react';
import { BandeauSuppression } from '../reglages/MonCompteCard.jsx';
import { aEncaisser, soldeApresAvoirs, totalAEncaisser } from '../../lib/impayes';
import { htDocument, htVente, ttcDocument } from '../../lib/vat';
import { Shell } from '../../components/layout/Shell.jsx';
import { BoutonContacts } from '../../components/BoutonContacts.jsx';
import { clientExistant } from '../../lib/contacts';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { _inp } from '../../components/ui/Inputs.jsx';
import { Pill } from '../../components/ui/Pill.jsx';
import { StatBox } from '../../components/ui/StatBox.jsx';
import { useSession } from '../../api/session.jsx';
import { useReglages } from '../../api/reglages.jsx';
import { idProvisoire } from '../../lib/identifiants';
import { ACCESS_ROLE } from '../../lib/access';
import { articlesAReapprovisionner } from '../../lib/valeur-stock';
import { chantierCosts } from '../../lib/costs';
import { achatsDuChantier, useAchatsJoints } from '../../components/ListeDuClient.jsx';
import { DEVISE, fmt } from '../../lib/currency';
import { joursRetard } from '../../lib/dates';
import { I18N, LANG, tr } from '../../lib/i18n';
import { CLE_TELETRAVAIL_ACCEPTE, constatDuBadge } from '../../lib/lieux-travail';
import { aujourdhuiIso } from '../../lib/utils';
import { MaJournee } from '../lieux/MaJournee.jsx';
import { termesOffre } from '../../lib/terminologie';
import { tauxTvaEnVigueur } from '../../lib/tva';
import { C } from '../../theme/palette';
import { TableauBord } from './TableauBord.jsx';
import { attendReponse, etatOffre } from '../../lib/etat-offre';

export function Accueil({
  onNav,
  prenom,
  essai,
  soc,
  clients,
  setClients,
  chantiers,
  setChantiers,
  devis,
  stock,
  ventes,
  conges,
  factures,
  employes,
  frais,
  enChargement = false,
  estMixte,
  univers,
  setUnivers,
}) {
  const trLocal = (s) => {
    const _p = soc?.pays;
    const _lg = !_p || _p === 'CH' ? 'fr-CH' : soc?.lang || LANG;
    return (I18N[_lg] && I18N[_lg][s]) || (I18N[LANG] && I18N[LANG][s]) || s;
  };
  const [cliAdd, setCliAdd] = useState(false);
  const [cliF, setCliF] = useState({ nom: '', adr: '', npa: '', tel: '', email: '' });
  const [cliForm, setCliForm] = useState(false);
  const [cliMsg, setCliMsg] = useState('');
  // Contact du carnet ou fiche .vcf : le formulaire se remplit de la même
  // façon, et reste à vérifier avant l'enregistrement.
  const recoitContact = (contact) => {
    setCliF(contact);
    setCliForm(true);
    const deja = clientExistant(clients, contact);
    setCliMsg(
      deja
        ? '⚠️ « ' +
            deja.nom +
            ' » est déjà dans tes clients : pas besoin de le créer une seconde fois.'
        : contact.nom
          ? '✓ « ' + contact.nom + ' » importé — vérifie puis enregistre.'
          : 'Contact importé — complète ci-dessous.',
    );
  };
  const contactEchoue = (message) => {
    setCliForm(true);
    setCliMsg(message);
  };
  const resetCli = () => {
    setCliF({ nom: '', adr: '', npa: '', tel: '', email: '' });
    setCliForm(false);
    setCliMsg('');
    setCliAdd(false);
  };
  const isMag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';

  // Le chiffre d'affaires est celui des factures : il oubliait la remise
  // globale qu'elles portent, et annoncait donc plus qu'il n'a ete facture.
  const htOf = htDocument;
  // Les factures de fournisseur jointes aux offres et factures comptent dans
  // la marge, comme sur la page du chantier.
  const achatsJoints = useAchatsJoints((factures || []).length + ':' + (devis || []).length);
  const totalBen = chantiers.reduce(
    (s, ch) =>
      s +
      chantierCosts(
        ch,
        employes,
        soc,
        factures,
        frais,
        achatsDuChantier(ch, achatsJoints, devis, factures),
      ).ben,
    0,
  );
  const caPayees = factures.filter((f) => f.statut === 'Payée').reduce((s, f) => s + htOf(f), 0);
  // Les prix du catalogue sont hors taxe, comme ceux des factures auxquelles
  // ces ventes s'additionnent : la TVA s'ajoute a l'encaissement.
  const caVentes = ventes.reduce((s, v) => s + htVente(v), 0);
  // Ce qui reste reellement a encaisser : le taux de 8.1 % etait applique en
  // bloc, et une facture deja payee en partie comptait pour son montant entier
  // — alors qu'elle etait par ailleurs signalee en retard.
  const impayes = totalAEncaisser(factures, devis);
  // Un avoir n'attend aucun paiement : il ne se relance pas.
  // Les mêmes factures que « Factures en retard » : une facture soldée par
  // son avoir n'est plus à relancer (6 annoncées pour 5 en retard).
  const facturesRetard = factures.filter(
    (f) => aEncaisser(f, devis, factures) && joursRetard(f) > 0,
  ).length;
  const congesEnAttente = conges.filter((c) => c.statut === 'En attente').length;
  const stockBas = articlesAReapprovisionner(stock).length;
  // Comme les cases « Mes offres et factures » et la liste des offres : une
  // offre déjà facturée n'est plus « en attente », ni « acceptée ».
  const dEnAtt = devis.filter((d) => attendReponse(d, factures));
  const devisEnAttente = dEnAtt.length;
  const ttcD = ttcDocument;
  const dAcc = devis.filter((d) => etatOffre(d, factures, chantiers) === 'Accepté');
  const dRef = devis.filter((d) => d.statut === 'Refusé');
  const fPay = factures.filter((f) => f.statut === 'Payée');
  const fEnv = factures.filter((f) => aEncaisser(f, devis, factures));
  const totEnAtt = dEnAtt.reduce((s, d) => s + ttcD(d), 0);
  const totAcc = dAcc.reduce((s, d) => s + ttcD(d), 0);
  const totRef = dRef.reduce((s, d) => s + ttcD(d), 0);
  const totPay = fPay.reduce((s, f) => s + ttcDocument(f), 0);
  const totEnv = fEnv.reduce((s, f) => s + soldeApresAvoirs(f, factures), 0);
  // Le nom de la piece suit Reglages → Documents, comme partout ailleurs.
  const termes = termesOffre(soc, { estMag: isMag });
  const motDevis = termes.mot;

  const saveCli = () => {
    if (!cliF.nom.trim()) return;
    const nid = idProvisoire();
    setClients((p) => [...p, { id: nid, ...cliF, remiseGlobale: 0, remises: {} }]);
    setCliF({ nom: '', adr: '', npa: '', tel: '', email: '' });
    setCliAdd(false);
  };

  const voitFinances = ACCESS_ROLE === 'patron' || ACCESS_ROLE === 'comptable';
  // Un compte qui n'a encore ni client, ni devis, ni chantier vient d'être
  // créé : le tableau de bord ne lui montrerait que des zéros. Le guide prend
  // sa place et s'efface de lui-même dès la première saisie.
  const debutant =
    (clients || []).length === 0 && (devis || []).length === 0 && (chantiers || []).length === 0;
  const stats = isMag
    ? voitFinances
      ? [
          ['CA ventes (encaissé)', DEVISE + ' ' + fmt(caVentes + caPayees), C.green, '🛒'],
          ['Impayés TTC', DEVISE + ' ' + fmt(impayes), C.amber, '⏳'],
          ['Alertes stock', String(stockBas), C.red, '📦'],
        ]
      : [
          ['Ventes récentes', String((ventes || []).length), C.green, '🛒'],
          ['Alertes stock', String(stockBas), C.red, '📦'],
          ['Congés à valider', String(congesEnAttente), C.teal, '🌴'],
        ]
    : voitFinances
      ? [
          [
            'Bénéfice chantiers',
            DEVISE + ' ' + fmt(totalBen),
            totalBen >= 0 ? C.green : C.red,
            '💰',
          ],
          ['Impayés TTC', DEVISE + ' ' + fmt(impayes), C.amber, '⏳'],
          [
            'Chantiers actifs',
            String(chantiers.filter((c) => c.statut === 'En cours').length),
            C.teal,
            '🏗️',
          ],
        ]
      : [
          [
            'Chantiers actifs',
            String(chantiers.filter((c) => c.statut === 'En cours').length),
            C.teal,
            '🏗️',
          ],
          [termes.Pluriel + ' en attente', String(devisEnAttente), C.amber, '📄'],
          ['Chantiers total', String(chantiers.length), C.navy, '🏗️'],
        ];
  const voitStock = ACCESS_ROLE === 'patron' || (soc?.permStock || {})[ACCESS_ROLE] === true;
  // Le patron rattache a sa propre fiche d'employe pointe, photographie et
  // rapporte comme un ouvrier : le raccourci mene droit a son espace, dans les
  // deux univers. Sans fiche, il reste la porte du bureau vers l'espace d'un
  // employe, au batiment.
  const { session } = useSession();
  const { reglageJson } = useReglages();
  const espaceTerrain = session?.role !== 'ouvrier' && session?.employeId != null;
  const roleDuBureau = ['technicien', 'directeur', 'secretaire', 'comptable'].includes(
    session?.role,
  );
  const pointeSaJournee = roleDuBureau && session?.employeId != null;
  // Le raccourci de l'espace terrain menait le secrétariat vers une page qui
  // le renvoyait à l'accueil : il pointe dans « Ma journée ».
  const raccourciTerrain = (!isMag || espaceTerrain) && !roleDuBureau;
  // Le télétravail pointé un jour non prévu, ce mois : le patron l'accepte.
  const moisCourant = aujourdhuiIso().slice(0, 7);
  const acceptesTeletravail = reglageJson(CLE_TELETRAVAIL_ACCEPTE, []) || [];
  const teletravailAAccepter = (employes || []).reduce(
    (n, e) =>
      n +
      (e.badges || []).filter(
        (b) =>
          String(b.date || '').slice(0, 7) === moisCourant &&
          constatDuBadge(b, e, acceptesTeletravail) === 'accepter',
      ).length,
    0,
  );
  const raccourcis = isMag
    ? [
        ['🛒', 'Vendre', 'ventes', C.green],
        ['🧾', 'Factures', 'factures', C.teal],
        ['📄', termes.Pluriel, 'devis', C.navy],
        ...(voitStock ? [['📦', 'Stock', 'stock', C.purple]] : []),
      ]
    : [
        ['📄', termes.nouveau, 'devis', C.navy],
        ['🧾', 'Factures', 'factures', C.teal],
        ['🏗️', 'Chantiers', 'chantiers', C.green],
        ['⋯', 'Plus', 'plus', C.amber],
      ];

  // Comme la maquette, « À traiter » suit le détail par période du tableau de
  // bord ; sans accès aux chiffres, elle suit les compteurs.
  const carteATraiter = (congesEnAttente > 0 ||
    teletravailAAccepter > 0 ||
    stockBas > 0 ||
    devisEnAttente > 0 ||
    facturesRetard > 0) && (
    <Card style={{ marginBottom: 12 }}>
      <Bar icon="🔔" title="À traiter" color={C.amber} />
      <div style={{ padding: '6px 13px 10px' }}>
        {facturesRetard > 0 && (
          <div
            onClick={() => onNav('factures', { filtre: 'Envoyée' })}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
              borderBottom: '1px solid ' + C.border,
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 10, color: C.ink }}>⏰ Factures en retard à relancer</span>
            <Pill label={String(facturesRetard)} color={C.red} />
          </div>
        )}
        {devisEnAttente > 0 && (
          <div
            onClick={() => onNav('devis')}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
              borderBottom: '1px solid ' + C.border,
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 10, color: C.ink }}>
              📄 {termes.Pluriel} en attente de réponse
            </span>
            <Pill label={String(devisEnAttente)} color={C.amber} />
          </div>
        )}
        {stockBas > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
              borderBottom: congesEnAttente > 0 ? '1px solid ' + C.border : 'none',
            }}
          >
            <span style={{ fontSize: 10, color: C.ink }}>📦 Articles sous le seuil de stock</span>
            <Pill label={String(stockBas)} color={C.red} />
          </div>
        )}
        {congesEnAttente > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
            }}
          >
            <span style={{ fontSize: 10, color: C.ink }}>🌴 Demandes de congés à valider</span>
            <Pill label={String(congesEnAttente)} color={C.teal} />
          </div>
        )}
        {teletravailAAccepter > 0 && (
          <div
            onClick={() => onNav('equipe')}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
              borderTop: '1px solid ' + C.border,
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 10, color: C.ink }}>{tr('🏠 Télétravail à accepter')}</span>
            <Pill label={String(teletravailAAccepter)} color={C.purple} />
          </div>
        )}
      </div>
    </Card>
  );

  // La fiche des clients et « + Nouveau client » : sous les meilleurs clients
  // quand le tableau de bord est là, seule sinon.
  const ficheClients = (
    <div style={{ padding: 12 }}>
      {!cliAdd ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div onClick={() => onNav('clients')} style={{ cursor: 'pointer' }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: C.ink }}>
              👥 Clients <span style={{ color: C.navy, fontSize: 9 }}>· voir tout ›</span>
            </div>
            <div style={{ fontSize: 9, color: C.muted, marginTop: 2 }}>
              {clients.length} fiche{clients.length > 1 ? 's' : ''}
            </div>
          </div>
          <Btn label="+ Nouveau client" sm color={C.green} onClick={() => setCliAdd(true)} />
        </div>
      ) : (
        <div>
          <div
            style={{
              fontSize: 11,
              fontWeight: 800,
              color: C.green,
              marginBottom: 8,
              textTransform: 'uppercase',
              letterSpacing: 0.4,
            }}
          >
            Nouveau client
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
            <BoutonContacts
              sm
              full
              color={C.navy}
              onContact={recoitContact}
              onEchec={contactEchoue}
            />
            <div style={{ flex: 1 }}>
              <Btn
                label="✍ Saisir à la main"
                sm
                ghost
                color={C.navy}
                full
                onClick={() => {
                  setCliForm(true);
                  setCliMsg('');
                }}
              />
            </div>
          </div>
          <div style={{ fontSize: 8, color: C.muted, marginBottom: 8, lineHeight: 1.4 }}>
            « Depuis mes contacts » ouvre le carnet du téléphone et remplit la fiche. Sinon, saisis
            à la main.
          </div>
          {cliMsg && (
            <div
              style={{
                background: C.navyXL,
                border: '1px solid ' + C.border,
                borderRadius: 8,
                padding: '8px 10px',
                fontSize: 9,
                color: C.grey,
                marginBottom: 8,
                lineHeight: 1.4,
              }}
            >
              {cliMsg}
            </div>
          )}
          {cliForm && (
            <div>
              <input
                value={cliF.nom}
                onChange={(e) => setCliF((p) => ({ ...p, nom: e.target.value }))}
                placeholder="Nom / société"
                style={{ ..._inp, marginBottom: 7 }}
              />
              <input
                value={cliF.adr}
                onChange={(e) => setCliF((p) => ({ ...p, adr: e.target.value }))}
                placeholder="Adresse"
                style={{ ..._inp, marginBottom: 7 }}
              />
              <input
                value={cliF.npa}
                onChange={(e) => setCliF((p) => ({ ...p, npa: e.target.value }))}
                placeholder="NPA / Ville"
                style={{ ..._inp, marginBottom: 7 }}
              />
              <div style={{ display: 'flex', gap: 7, marginBottom: 7 }}>
                <input
                  value={cliF.tel}
                  onChange={(e) => setCliF((p) => ({ ...p, tel: e.target.value }))}
                  placeholder="Téléphone"
                  style={{ ..._inp }}
                />
                <input
                  value={cliF.email}
                  onChange={(e) => setCliF((p) => ({ ...p, email: e.target.value }))}
                  placeholder="E-mail"
                  style={{ ..._inp }}
                />
              </div>
              <div style={{ display: 'flex', gap: 7 }}>
                <div style={{ flex: 1 }}>
                  <Btn
                    label="✓ Enregistrer"
                    sm
                    color={C.green}
                    full
                    disabled={!cliF.nom.trim()}
                    onClick={saveCli}
                  />
                </div>
                <Btn label="Annuler" sm ghost color={C.grey} onClick={resetCli} />
              </div>
            </div>
          )}
          {!cliForm && (
            <div style={{ textAlign: 'right' }}>
              <span
                onClick={resetCli}
                style={{
                  fontSize: 9,
                  color: C.muted,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                Annuler
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <Shell
      active="accueil"
      onNav={onNav}
      soc={soc}
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <BandeauSuppression onNav={onNav} />
      {enChargement && (
        <div
          role="status"
          style={{
            background: C.navyXL,
            color: C.navy,
            borderRadius: 10,
            padding: '8px 12px',
            fontSize: 11,
            fontWeight: 700,
            marginBottom: 10,
            textAlign: 'center',
          }}
        >
          ⏳ {trLocal('Chargement des chiffres…')}
        </div>
      )}
      {!enChargement && debutant && (
        <Card style={{ marginBottom: 12, border: '2px solid ' + C.green }}>
          <div style={{ padding: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 900, color: C.navy, marginBottom: 4 }}>
              👋 Bienvenue sur SwissTech !
            </div>
            <div style={{ fontSize: 12, color: C.grey, marginBottom: 10 }}>
              Pour bien démarrer, en 4 étapes :
            </div>
            {[
              ['1️⃣', 'Configure ton entreprise —', 'Plus → Réglages'],
              ['2️⃣', 'Ajoute tes', 'clients et tes articles'],
              ['3️⃣', 'Crée ton', '1er devis'],
              ['4️⃣', 'Transforme-le en', 'facture QR en 1 clic'],
            ].map(([n, texte, gras]) => (
              <div key={n} style={{ fontSize: 12.5, color: C.navy, padding: '4px 0' }}>
                {n} {texte} <b>{gras}</b>
              </div>
            ))}
            <div style={{ fontSize: 10, color: C.muted, marginTop: 9 }}>
              💡 Ce guide disparaît dès que tu commences à utiliser l&apos;app.
            </div>
          </div>
        </Card>
      )}
      <div style={{ fontSize: 16, fontWeight: 900, color: C.ink, margin: '2px 2px 12px' }}>
        Bonjour{' '}
        {/* Le prénom de la personne connectée ; jamais le premier mot du nom de
            la société, qui faisait lire « Bonjour Test » à la secrétaire. */}
        <span style={{ color: C.navy }}>{prenom || '👋'}</span>
      </div>
      {/* La secrétaire, la comptable et le technicien pointent leur journée
          ici : au bureau, au dépôt ou de chez eux. */}
      {pointeSaJournee && <MaJournee chantiers={chantiers} setChantiers={setChantiers} />}
      {/* Les jours d'essai, dans la page : la pastille flottante cachait le
          bénéfice net sur l'iPhone. */}
      {essai && (
        <div
          className="no-print"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 9,
            background: C.navy,
            color: '#fff',
            borderRadius: 99,
            padding: '7px 8px 7px 14px',
            fontSize: 10.5,
            fontWeight: 700,
            margin: '-4px 2px 12px',
            width: 'fit-content',
          }}
        >
          <span onClick={() => onNav('abonnement')} style={{ cursor: 'pointer' }}>
            {'🎁 Essai gratuit · ' +
              essai.jours +
              ' jour' +
              (essai.jours > 1 ? 's' : '') +
              ' restant' +
              (essai.jours > 1 ? 's' : '')}
          </span>
          <button
            type="button"
            aria-label="Masquer"
            onClick={essai.masque}
            style={{
              background: 'rgba(255,255,255,.18)',
              border: 'none',
              color: '#fff',
              borderRadius: 99,
              width: 20,
              height: 20,
              fontSize: 11,
              cursor: 'pointer',
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
        {raccourcis.map(([ic, lb, route, col, params]) => (
          <div
            key={lb}
            onClick={() => onNav(route, params)}
            style={{
              background: C.white,
              border: '1px solid ' + C.border,
              borderRadius: 12,
              padding: '13px 14px',
              display: 'flex',
              alignItems: 'center',
              gap: 11,
              cursor: 'pointer',
            }}
          >
            <span
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: col + '18',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 16,
              }}
            >
              {ic}
            </span>
            <span style={{ fontSize: 11, fontWeight: 800, color: C.ink }}>{lb}</span>
          </div>
        ))}
      </div>

      {voitFinances ? (
        <TableauBord
          soc={soc}
          estMixte={estMixte}
          onNav={onNav}
          factures={factures}
          devis={devis}
          chantiers={chantiers}
          employes={employes}
          clients={clients}
          frais={frais}
          impayes={impayes}
          stock={stock}
          isMag={isMag}
          ventes={ventes}
          tauxVentes={tauxTvaEnVigueur(soc).normal}
          aTraiter={carteATraiter}
          carteClients={ficheClients}
        />
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3,1fr)',
            gap: 8,
            marginBottom: 14,
          }}
        >
          {stats.map(([lb, v, c, ic]) => (
            <StatBox key={lb} label={lb} value={v} color={c} icon={ic} />
          ))}
        </div>
      )}

      {!voitFinances && carteATraiter}

      {/* Récapitulatif chiffré, pour qui ne voit pas le tableau de bord : il
          y répétait « Mes offres et factures ». */}
      {!voitFinances && (
        <Card style={{ marginBottom: 12 }}>
          <Bar
            icon="📊"
            title="Récapitulatif"
            color={C.navy}
            sub={termes.Pluriel + ' et factures — nombre et montant total'}
          />
          <div style={{ padding: '6px 13px 12px' }}>
            <div
              onClick={() => onNav('devis')}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid ' + C.border,
                cursor: 'pointer',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 15 }}>⏳</span>
                <div>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: C.ink }}>
                    {termes.Pluriel} en attente
                  </div>
                  <div style={{ fontSize: 8.5, color: C.muted }}>
                    {/* Le pluriel du terme porte déjà son « s » (« offres ») ; et
                      une offre se dit au féminin. */}
                    {dEnAtt.length} {dEnAtt.length > 1 ? termes.pluriel : termes.mot} non répondu
                    {(termes.feminin ? 'e' : '') + (dEnAtt.length > 1 ? 's' : '')}
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, fontWeight: 900, color: C.amber }}>{dEnAtt.length}</div>
                {voitFinances && (
                  <div style={{ fontSize: 9, fontWeight: 700, color: C.grey }}>
                    {DEVISE} {fmt(totEnAtt)}
                  </div>
                )}
              </div>
            </div>
            <div
              onClick={() => onNav('devis')}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid ' + C.border,
                cursor: 'pointer',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 15 }}>✅</span>
                <div>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: C.ink }}>
                    {termes.feminin ? 'Offres acceptées' : 'Devis acceptés'}
                  </div>
                  <div style={{ fontSize: 8.5, color: C.muted }}>
                    {dAcc.length} accepté
                    {(termes.feminin ? 'e' : '') + (dAcc.length > 1 ? 's' : '')}
                    {dRef.length > 0
                      ? ' · ' +
                        dRef.length +
                        ' refusé' +
                        (termes.feminin ? 'e' : '') +
                        (dRef.length > 1 ? 's' : '')
                      : ''}
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, fontWeight: 900, color: C.green }}>{dAcc.length}</div>
                {voitFinances && (
                  <div style={{ fontSize: 9, fontWeight: 700, color: C.grey }}>
                    {DEVISE} {fmt(totAcc)}
                  </div>
                )}
              </div>
            </div>
            <div
              onClick={() => onNav('factures', { filtre: 'Payée' })}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid ' + C.border,
                cursor: 'pointer',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 15 }}>🧾</span>
                <div>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: C.ink }}>
                    Factures payées
                  </div>
                  <div style={{ fontSize: 8.5, color: C.muted }}>
                    {fPay.length} payée{fPay.length > 1 ? 's' : ''}
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, fontWeight: 900, color: C.green }}>{fPay.length}</div>
                {voitFinances && (
                  <div style={{ fontSize: 9, fontWeight: 700, color: C.grey }}>
                    {DEVISE} {fmt(totPay)}
                  </div>
                )}
              </div>
            </div>
            <div
              onClick={() => onNav('factures', { filtre: 'Envoyée' })}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0',
                cursor: 'pointer',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 15 }}>📤</span>
                <div>
                  <div style={{ fontSize: 10.5, fontWeight: 700, color: C.ink }}>
                    Factures en attente de paiement
                  </div>
                  <div style={{ fontSize: 8.5, color: C.muted }}>
                    {fEnv.length} envoyée{fEnv.length > 1 ? 's' : ''} non payée
                    {fEnv.length > 1 ? 's' : ''}
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, fontWeight: 900, color: C.amber }}>{fEnv.length}</div>
                {voitFinances && (
                  <div style={{ fontSize: 9, fontWeight: 700, color: C.grey }}>
                    {DEVISE} {fmt(totEnv)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      )}
      {!voitFinances && <Card style={{ marginBottom: 12 }}>{ficheClients}</Card>}

      {/* Raccourcis */}
      {raccourciTerrain && (
        <div
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            color: C.muted,
            margin: '2px 2px 8px',
          }}
        >
          Raccourcis
        </div>
      )}

      {raccourciTerrain && (
        <div
          onClick={() => onNav('ouvrier')}
          style={{
            background: 'linear-gradient(135deg,' + C.teal + ',' + C.navy + ')',
            borderRadius: 14,
            padding: '15px 16px',
            marginBottom: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 13,
            cursor: 'pointer',
            boxShadow: '0 6px 18px rgba(13,148,136,.28)',
          }}
        >
          <span
            style={{
              width: 42,
              height: 42,
              borderRadius: 11,
              background: 'rgba(255,255,255,.18)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 22,
            }}
          >
            👷
          </span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 12.5, fontWeight: 900, color: '#fff' }}>
              {espaceTerrain ? 'Mon espace terrain' : 'Espace employé'}
            </div>
            <div
              style={{
                fontSize: 9,
                color: 'rgba(255,255,255,.85)',
                marginTop: 2,
                lineHeight: 1.4,
              }}
            >
              {espaceTerrain
                ? 'Pointer · photos · rapport du jour · mon salaire — sur ma fiche'
                : 'Pointer mes heures · adresse du chantier · rapport du jour'}
            </div>
          </div>
          <span style={{ fontSize: 18, color: '#fff' }}>›</span>
        </div>
      )}
    </Shell>
  );
}
